import { render, staticRenderFns } from "./GroupedEventGrid.vue?vue&type=template&id=ed37717e&lang=pug"
import script from "./GroupedEventGrid.vue?vue&type=script&lang=js"
export * from "./GroupedEventGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports